
export enum UserTypeEnum {
    User = 'User',
    Group = 'Group',
    Role = 'Role'
}
